import { Component, EventEmitter, OnInit, Output, input, ChangeDetectionStrategy } from '@angular/core'; // ###
import { JkBaseComponent } from '../jkbase/jkbase.component';

export type Orientation = 'horizontal' | 'vertical';

@Component({
    selector: 'app-jkimage',
    templateUrl: './jkimage.component.html',
    styleUrls: ['./jkimage.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [],
})
export class JkimageComponent extends JkBaseComponent  implements OnInit {
  override comType: string = 'jkimage';
  readonly items = input<any[]>([]);
  readonly height = input<string>('390');
  readonly baseItemHeight = input<number>(120);
  readonly baseItemWidth = input<number>(185);
  //@Input() direction: string = 'horizontal';
  readonly direction = input<Orientation>('horizontal');
  //@Input() width: string = '100%';

  exist: boolean = false;
  readonly url = input<string>('');
  constructor() {
    super();
    this.width.set('100%');
   }

  override ngOnInit() {
    super.ngOnInit();
  }
  checkUrl(url:string): boolean {
    let result = false;
    //let u = new URL(url);
    //this.exist = isUrl(url);
    //result = URL.parse
    return result;
  }
}


